<script lang="ts">
  import { assets } from "$app/paths";
  import { defaultColour, findColour } from "$lib/data/colours.data";
  import type { colour, colourVariant } from "$lib/data/colours.data";
  import Typography from "$lib/components/Typography/Typography.svelte";
  import { onMount } from "svelte";

  export let count = 0;
  export let colourOption: colourVariant;
  export let inStock: boolean;
  export let label: string;
  export let plain: boolean;
  export let rounded = true;
  export let withBorder = false;

  let colourInfo: colour = defaultColour;

  $: if (colourOption) {
    colourInfo = findColour(colourOption.identifier);
  }

  let viewportWidth: number;
  let isMobile = false;
  let mdWidth = 768;

  onMount(() => {
    const bodyStyle = getComputedStyle(document.body);
    mdWidth = Number(bodyStyle.getPropertyValue("--md").replace(/\D/g, ""));
  });

  $: isMobile = viewportWidth < mdWidth;
</script>

<style lang="scss">
  .colour-inner {
    &--option {
      width: 16px;
      height: 16px;

      &--with-border {
        border: 1px solid $inverse-on-surface;
      }

      &__light {
        width: 16px;
        height: 16px;
        border: 1px solid $on-surface-30;
        border-radius: 50%;
      }
    }

    &--rounded {
      border-radius: 50%;
    }

    &--border {
      padding: 4px;
    }

    &--label {
      display: flex;
      align-items: center;
      background-color: transparent;
      border: none;
      margin: 0;
      padding-left: 9px;
    }

    &--count {
      padding-left: 4px;
    }
  }
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>

<svelte:window bind:innerWidth={viewportWidth} />

<div class={`${$$props.class} colour-inner--border`}>
  <div
    class={`colour-inner--option  ${rounded && "colour-inner--rounded"} ${
      !withBorder && colourInfo.light ? "colour-inner--option__light" : ""
    } ${withBorder ? "colour-inner--option--with-border" : ""}`}
    style={`background-color:${colourInfo.hex}; `}
  >
    <div class="colour-inner--out-of-stock">
      {#if colourInfo.light && !inStock}
        <img src={`${assets}/svg/cross-dark.svg`} alt="Colour out of stock" />
      {:else if !inStock}
        <img src={`${assets}/svg/cross-light.svg`} alt="Colour out of stock" />
      {/if}
    </div>
  </div>
</div>

{#if label}
  <div class="colour-inner--label">
    <div>
      <Typography
        variant="button1"
        component="span"
        theme={count <= 0
          ? "inverse-on-surface-60"
          : isMobile
            ? "on-surface"
            : "inverse-on-surface"}>{label}</Typography
      >
    </div>
    {#if plain}
      <div class="colour-inner--count">
        {#if count < 10}
          <Typography
            variant="caption1"
            component="span"
            theme={count <= 0
              ? "inverse-on-surface-60"
              : isMobile
                ? "on-surface"
                : "surface"}>0{count}</Typography
          >
        {:else}
          <Typography
            variant="caption1"
            component="span"
            theme={count <= 0
              ? "inverse-on-surface-60"
              : isMobile
                ? "on-surface"
                : "surface"}>{count}</Typography
          >
        {/if}
      </div>
    {:else}
      <div class="colour-inner--count">
        <Typography variant="caption1" component="span">{count}</Typography>
      </div>
    {/if}
  </div>
{/if}
